// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__12CLt","notes":"Notes_notes__3L1ft"};